import BlogMeta from "./blogMeta";
import ConvertKitForm from "./convertKitForm";

const Layout = ({ children, frontMatter }) => {
  return (
    <div>
      <div className="mt-16 lg:mt-32">
        <div className="xl:relative">
          <div className="mx-auto max-w-2xl">
            <article>
              <BlogMeta meta={frontMatter} />
              <div className="prose mt-8 px-4">{children}</div>
            </article>
          </div>
        </div>
      </div>
      <ConvertKitForm />
    </div>
  );
};

export default Layout;
